(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const toggleBtn = document.getElementById('mbt-filter-toggle');
    const closeBtn  = document.getElementById('mbt-filter-close');
    const overlay   = document.getElementById('mbt-filter-overlay');
    const sidebar   = document.getElementById('mbt-filter-sidebar');

    function openDrawer() {
      sidebar.classList.add('is-open');
      overlay.classList.add('is-visible');
      overlay.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      sidebar.classList.remove('is-open');
      overlay.classList.remove('is-visible');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
    }

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        openDrawer();
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
      });
    }

    if (overlay) {
      overlay.addEventListener('click', function(e) {
        e.stopPropagation();
        closeDrawer();
      });
    }

    /* Close on Escape key */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && sidebar.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    /*
      Prevent Ritual theme's own click handlers from
      intercepting events inside our custom sidebar
    */
    if (sidebar) {
      sidebar.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
